<script>
import RawData from "@/components/widgets/raw-data.vue";
import BidSchedules  from "./bid-schedules.vue"
import BidDetails from "./bid-details.vue"
import BidItems from "./bid-items.vue"
import BACMembers from "./bac-members.vue"
import BidSuppliers from "./supplier-offers.vue"
import BidAttachments from "./bid-attachments.vue"
import BidPublicPost from "./bid-public-post.vue"
import RfqFilePostingModal from "@/components/modals/rfq-file-posting.vue";
import EmployeeModal from '@/components/modals/employee.vue';
import SupplierRfq from "@/components/modals/supplier-rfq";
import SupplierOfferModal from "@/components/modals/supplier-offer";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import PublicPostModal from "@/components/modals/public-posting.vue"
import PrintOptions from "@/components/modals/print-options.vue";
import Unit from "@/components/modals/unit.vue";
import BidItemModal from "@/components/modals/bid-item.vue";
import BidActivityModal from "@/components/modals/bid-activity.vue"
import RFQNumberModal from "@/components/modals/rfq-number.vue";
import BACMemberModal from '@/components/modals/bac-member.vue'
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import {cloneDeep, orderBy, sortBy} from 'lodash';
import Swal from "sweetalert2";
export default {
    components: {
        RawData,
        BidDetails,
        BidItems,
        BACMembers,
        BidAttachments,
        BidPublicPost,
        RfqFilePostingModal,
        EmployeeModal,
        SupplierRfq,
        BidSuppliers,
        SupplierOfferModal,
        AttachmentModal,
        PrintOptions,
        PublicPostModal,
        Unit,
        BidItemModal,
        BidSchedules,
        BidActivityModal,
        RFQNumberModal,
        BACMemberModal,
        ApiResourceLogs
    },
    props: {
        bidActivities: Array,
        rfqData: Array,
        loading: Boolean,
        filter: null,
        perPage: [Number, String],
        publicPostLabels: Array,
        units: Array,
        rfqType: String,
        menuOpt: Number,
        selectedPRs: Array
    },
    data(){
        return {
            uploadOptions: {
                type: "Bids & Quotations",
                placement: "lefttop",
                folder: "Procurement",
            },
            publicPostOptions: {
                type: "RFQ Public Post",
                placement: "lefttop",
                folder: "Procurement",
            },
            multipleFilePosting: [],
            filePostingType: 'add',
            modalTitle: '',
            publicPostLoading: false,
            selectedRFQ: null,
            suppliers: [],
            selectedSupplier: null,
            selectedSupplierIndex: -1,
            selectedSupplierId: 0,
            offers: [],
            wActions: true,
            updateUnit: null,
            selectedRfqItem: null,
            modalHeader: null,
            modalSubheader: null,
            currentPage: 1,
            filteredHeader: [],
            selectedRFQForChanging: null
        }
    },
    computed: {
        filteredRfqs(){
            let data = this.rfqData;
            if(this.perPage === 'All'){
                return data;
            }
            var total = this.currentPage * this.perPage;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            data = data.slice(total - this.perPage, total);
            return data;
        },
        rows() {
            let data = this.rfqData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        }
    },
    methods: {
        async selectRfq(pr){
            pr.expand = !pr.expand;
            if(pr.rfq){
                this.showRfqActivities(pr.rfq);
            }else{
                this.showPrItems(pr);
            }
        },
        async getRFQBacMembers(row){
            if(row.rfqBacSettings.length == 0){
                row.bacLoading = true;
                await this.$store
                    .dispatch("rfqbacsetting/GetRfqBacSetting", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.error, "error");
                        }
                        row.rfqBacSettings = res.data;
                    })  
                row.bacLoading = false;
            }
        },
        async showPrItems(pr){
            if(pr.prItems.length == 0){
                this.getPrItems(pr)
            }
        },
        async getPrItems(row){
            this.$store
                .dispatch("pritem/GetPrItemsSummary", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.erroMessage,
                            "warning"
                        );
                    }
                    if(res.data.items){
                        row.prItems = sortBy(res.data.items, "itemName")
                    }else{
                        row.prItems = []
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async showRfqActivities(row){
            if(row.activities.length == 0){
                this.getRfqActivities(row)
            }
        },
        async getRfqActivities(row){
            row.activityLoading = true;
            await this.$store
                .dispatch("bidactivityschedule/GetBidActivityScheduleByRfq", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.error, "error");
                    }
                    row.activities = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            row.activityLoading = false;
        },
        async showRfqItems(row){
            row.itemVisible = !row.itemVisible
            if(row.itemVisible && row.rfqItems.length == 0){
                this.getRfqItems(row)
            }
        },
        async getRfqItems(row){
            row.rfqItemLoading = true;
            row.rfqItems = [];
            await this.$store
                .dispatch("rfqitem/GetRfqItems", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.error, "error");
                    }
                    let reAward = false;
                    res.data.forEach((x) => {
                        x.selected = false;
                        x.sortName = x.sortName = x.sort > 0 ? x.sort : x.itemName.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/\s+/g,'').replace(/'/g, '').trim().toLowerCase();
                        x.sortDescription = x.description.replace(/\s+/g,'').replace(/[\r\n]/gm, '').replace(/'/g, '').replace('-', '').replace('–', '').replace(':', '1').trim().toLowerCase();
                        if(row.rfqNumber === 'CDO-NP-SVP-2024-0584'){
                            if(x.itemName.includes('Antibacterial Handwash 500ml')){
                                x.sortName = `   ${x.sortName}`;
                            }
                            if(x.itemName.includes('Cotton Rolls 100g')){
                                x.sortName = `  ${x.sortName}`;
                            }
                        }
                        x.total = parseFloat(x.unitCost) * parseFloat(x.quantity);
                        x.grouped = false;
                        x.offer = {
                            id: 0,
                            rfqSupplierId: 0,
                            rfqItemId: x.id,
                            itemName: cloneDeep(x.itemName),
                            description: cloneDeep(x.description),
                            unitId: "",
                            unit: x.unit,
                            quantity: cloneDeep(x.quantity).toString(),
                            unitCost: "",
                            note: "",
                            isWinner: false,
                            totalAmt: parseFloat(x.unitCost) * parseFloat(x.quantity),
                            specification: "",
                            brand: "",
                            model: "",
                            color: "",
                            dimensionDescription: "",
                            materialUsed: "",
                            packageDescription: "",
                            condition: "",
                            deliveryPeriod: "7",
                        };
                        x.prItem = { id: x.prItemId, status: 'Approved'}
                        if(x.isReAward){
                            reAward = true;
                        }
                    });
                    row.reAward = reAward;
                    row.rfqItems = orderBy(res.data, ['sortName', 'sortDescription', 'quantity'], ['asc', 'asc', 'desc']);
                    row.copyItems = cloneDeep(row.rfqItems);
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting cart items",
                        "error"
                    );
                });   
            row.rfqItemLoading = false;
        },
        async getAttachments(row, activities) {
            if(row.rfqFiles.length) return;
            row.rfqFiles = [];
            row.fileSearch = "";
            row.attachmentLoading = true;
            await this.getActivityFiles(row, activities);
            await this.getOthers(row);
            row.attachmentLoading = false;
        },
         async getActivityFiles(row, activities){
            for await(const x of activities){
                await this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: x.id,
                        type: 'Bid Activity',
                    })
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        if(res.data.length){
                            row.rfqFiles.push({
                                title: x.activityName,
                                files: res.data
                            })
                        }
                    })
                    .catch(() => {})
            }
        },
        async getOthers(row){
            await this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                })
                .then((res) => {
                    row.rfqFiles.push({
                        title: 'Others',
                        files: res.data
                    })
                })
                .catch(() => {
                    this.showToast("Something went wrong! - getting documents", "error");
                });
        },
        async getPublicPostAttachments(row) {
            if(row.posts.length > 0) return;
            row.postLoading = true;
            await this.$store
                .dispatch("rfqpostingfile/GetRfqPostingFiles", row.publicPostId)
                .then(async (res) => {
                    for await(const item of res.data){
                        let attachments = [];
                        await this.$store.dispatch("filemanager/GetFiles", {id: item.id, type: this.publicPostOptions.type}).then(res => {
                            attachments = res.data;
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                        item.attachments = attachments;
                        item.showAttachment = false;
                        item.searchKey = `${item.title} ${item.description}`
                    }
                    row.posts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            row.postLoading = false;
        },
        async addPublicPost(row){
            this.multipleFilePosting = [];
            this.filePostingType = 'add';
            this.modalTitle = 'Add Public Post Attachment';
            this.selectedRFQ = row;
            this.$bvModal.show('rfq-posting-file-modal');
            if(this.publicPostLabels.length == 0){
                this.publicPostLoading = true;
                await this.getPublicPostLabels();
                this.publicPostLoading = false;
            }
            this.multipleFilePosting.push({
                id: 0,
                title: '',
                description: '',
                search: false,
            })
        },
        async saveFilePosting(data){
            data.map(x => {
                x.title = x.title.trim();
                x.description = x.description.trim();
                x.publicPostedRfqId = this.selectedRFQ.publicPostId;
            });
            let fillUpFields = false;
            data.forEach(x => {
                if(x.title.trim() === ''){
                    fillUpFields = true;
                }
            });
            if(fillUpFields){
                return this.showToast('Please fill up all fields', 'warning');
            }
            if(this.filePostingType === 'add'){
                let error = 0;
                for await (const item of data) {
                    await this.$store.dispatch('rfqpostingfile/CreateRfqPostingFile', item)
                        .then(res => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            item.id = res.data.id;
                            item.showAttachment = false;
                            item.attachments = [];
                        })
                        .catch(() => {
                            error++;
                        });
                    this.selectedRFQ.posts.push(item);
                }
                if(error > 0){
                    return this.showToast("Something went wrong!", "error");
                }
                this.showToast('Successfully added!', 'success');
                this.$bvModal.hide('rfq-posting-file-modal');
            }else{
                let item = data[0];
                await this.$store.dispatch('rfqpostingfile/UpdateRfqPostingFile', item)
                    .then(res => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.selectedRFQ.posts.findIndex(x => x.id == item.id);
                        this.selectedRFQ.posts.splice(index, 1, item)
                        this.showToast('Successfully updated!', 'success');
                        this.$bvModal.hide('rfq-posting-file-modal');
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        async updatePublicAttachment(row, parent){
            this.multipleFilePosting = [];
            this.filePostingType = 'update';
            this.modalTitle = 'Update Public Post Attachment';
            this.selectedRFQ = parent;
            this.$bvModal.show('rfq-posting-file-modal');
            if(this.publicPostLabels.length == 0){
                this.getPublicPostLoading = true;
                await this.getPublicPostLabels();
                this.getPublicPostLoading = false;
            }
            this.multipleFilePosting.push(cloneDeep(row))
        },
        deleteBACMember(row, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$store.dispatch('rfqbacsetting/DeleteBACMember', row.id).then(res => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = parent.rfqBacSettings.findIndex(x => x.id == row.id);
                        parent.rfqBacSettings.splice(index, 1);
                        this.showToast('Successfully removed!', 'success');
                    }).catch(err => {
                        this.showToast('Something went wrong!', 'error');
                    });
                }
            });
        },
        updateBACMember(row, parent){
            this.selectedBACMember = row;
            this.selectedPR = parent;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        selectBACEmployee(){
            this.selectedBACMember = null;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        addBACMember(parent){
            this.selectedPR = parent;
            this.$bvModal.show('add-member-modal');
        },
        dropSingleEmployee(e) {
            if(!this.selectedBACMember){
                this.$refs.addBacModal.dropEmployee(e);
            }else{
                Swal.fire({
                    title: "Are you sure?",
                    text: this.selectedBACMember ? "You want to change BAC Member?" : 'You want to add BAC Member',
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: `Yes, ${this.selectedBACMember ? 'change' : 'add'} it!`,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                            this.pageLoader(true);
                            let data = {
                                id: this.selectedBACMember.id,
                                applicationUserId: e.applicationUser.id,
                            };
                            await this.$store.dispatch('rfqbacsetting/ChangeBACMember', data).then(res => {
                                if(res.data.error){
                                    return this.showToast(res.data.errorMessage, 'error');
                                }
                                this.selectedBACMember.applicationUser = e.applicationUser;
                                this.selectedBACMember.employeeName = e.applicationUser.completeName;
                                this.showToast('Successfully changed!', 'success');
                            }).catch(err => {
                                this.showToast('Something went wrong!', 'error');
                            });
                            this.pageLoader(false);
                    }
                });
            }
        },
        async showRfqSupplier(x) {
            if (!x.itemLoaded) {
                x.itemLoading = true;
                if(x.rfqItems.length == 0){
                    await this.getRfqItems(x);
                }
                await this.getInvitedSupplier(x)
                await this.getRfqSupplier(x);
                x.itemLoading = false;
            }
        },
        async getRfqSupplier(x){
            await this.$store
                .dispatch("rfqsupplier/GetSingleRfqSupplierByRFQ", x.id ? x.id : x.rfqId)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((z) => {
                        var rfqItems = cloneDeep(x.rfqItems);
                        z.isWinner = false;
                        rfqItems.forEach((w) => {
                            let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                            if (offer) {
                                offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                offer.showMoreSpec = false;
                                offer.deliveryPeriod = parseFloat(offer.deliveryPeriod) > 0 ? parseFloat(offer.deliveryPeriod).toString() : "7";
                                rfqItems[rfqItems.indexOf(w)].offer = offer;
                                if(offer.isWinner){
                                    z.isWinner = true;
                                }
                            }
                        });
                        z.supplierRFQ = rfqItems;
                        z.visible = false;
                    });
                    x.itemLoaded = true;
                    x.rfqSuppliers = sortBy(res.data, ['supplier.name']);
                    let countPOExist = 0;
                    let isWinner = 0;
                    x.rfqSuppliers.map(item => {
                        countPOExist += item.withPo ? 1 : 0;
                        isWinner += item.isWinner ? 1 : 0;
                    })
                    x.poExist = countPOExist == isWinner;
                    // x.poExist = x.rfqSuppliers.filter(x=> x.withPo).length > 0 ? false : true;
                })
                .catch((err) => {
                    this.showToast("RFQ Item went wrong!", "error");
                });
        },
        async getInvitedSupplier(x){
            await this.$store
                .dispatch("rfqsupplier/GetInvitedSupplier", x.id ? x.id : x.rfqId)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    x.invitedSuppliers = res.data;
                }).catch((err) => {
                    this.showToast("Getting Invited Supplier went wrong!", "error");
                });
        },
        async addMoreSupplier(row){
            let ssup = [];
            this.suppliers = [];
            row.rfqSuppliers.forEach((item) => {
                ssup.push(item.supplier);
            });
            this.$refs.supplier.onModalOpen({ supplierSelected: ssup });
            await this.$refs.supplier.getData(row.id);
            let suppliers = this.$refs.supplier.getSuppliers();
            suppliers.forEach((item) => {
                !item.selectedSup && this.suppliers.push(item);
            });
            row.addSupplier = true;
        },
        dropSuppliers(data) {
            this.selectedSupplier = cloneDeep(data);
        },
        async saveOfferMethod(data) {
            let done = 0;
            for (const offer of data) {
                let offerRequest = cloneDeep(offer);
                offerRequest.unitCost = this.getExactAmt(offer.unitCost);
                offerRequest.quantity = this.getExactAmt(offer.quantity);
                offerRequest.itemName = offer.itemName.trim();
                offerRequest.description = offer.description.trim();
                if (offer.id > 0) {
                    await this.$store
                        .dispatch("rfqsupplieroffer/UpdateRSO", offerRequest)
                        .then((res) => {
                            this.offers[offer.index].offer = offerRequest;
                            done++;
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                } else {
                    await this.$store
                        .dispatch("rfqsupplieroffer/CreateRSO", offerRequest)
                        .then((res) => {
                            offerRequest.id = res.data.id;
                            this.offers[offer.index].offer = offerRequest;
                            done++;
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                }
            }
            if (done == data.length) {
                this.showToast("Successfully saved!", "success");
                this.selectedRFQ.rfqSuppliers[this.selectedSupplierIndex].supplierRFQ = this.offers;
                this.offers = [];
                this.selectedSupplierIndex = -1;
                this.$bvModal.hide("offer-modal");
            }
        },
        async updateOffer({data, index, id, returnDate}, parent){
            this.offers = cloneDeep(data);
            this.selectedSupplierIndex = cloneDeep(index);
            this.selectedSupplierId = cloneDeep(id);
            this.selectedRFQ = parent;
            this.returnDate = returnDate === '0001-01-01T00:00:00' ? new Date() : new Date(returnDate);
            this.modalTitle = `Update Offer`;
            this.$bvModal.show("offer-modal");
            await this.$nextTick();
            this.$refs.supOfferModal.stretchInput(returnDate);
        },
        updateReturnDate(data){
            this.selectedRFQ.rfqSuppliers[this.selectedSupplierIndex].rfqReturnDate = data;
        },
        addAttachment(row, wActions){
            this.wActions = wActions;
            let id = row ? row.id : this.selectedSupplierId;
            this.modalTitle = 'Supplier Offer Attachment'
            this.$refs.attachmentModal.setUploadOpt({
                type: "RFQ Supplier Item Offer",
                placement: "left",
                folder: "Procurement",
            });
            this.$refs.attachmentModal.getData(id);
            this.$bvModal.show("upload-attachment-modal");
        },
        printRFQ(id, type) {
            if(type === 'blank'){
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/RFQ/Blank",
                    routeVariables: [id],
                });
            }else{
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/RFQ",
                    routeVariables: [id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        printAbstract(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Abstract",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printInvitation(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/InvitationToBid",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printInstruction(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/InstructionToBidders",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printDataSheet(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/BidDataSheet",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printGeneralContract(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/GeneralConditionsOfContract",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSpecialContract(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/SpecialConditionsOfContract",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSchedReq(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ScheduleOfRequirements",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printChecklist(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ChecklistOfTechnicalAndFinancialDocuments",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSchedules(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ScheduleOfBiddingActivities",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        deleteRFQ(id){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfq/DeleteRfq", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.rfqData.findIndex(x => x.id == id);
                            this.rfqData.splice(index, 1);
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async changeUnit(rfqItem, parent){
            this.selectedRfqItem = rfqItem;
            this.selectedRFQ = parent;
            this.pageLoader(true);
            try{
                const {data} =  await this.$store.dispatch("apiresource/GetSinglePPMPItem", rfqItem.apiResourceId)
                this.updateUnit = data;
                this.$refs.unit.tableData = cloneDeep(this.units);
                this.$bvModal.show("unit-modal");
            }catch(err){
                this.showToast("Something went wrong!", "error");
            }
            this.pageLoader(false);
        },
        dropUnit(data) {
            Swal.fire({
                title: "Are you sure?",
                text: `You want to update the unit from ${this.selectedRfqItem.unit.shortName} to ${data.shortName}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, update it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                let requestData = cloneDeep(this.updateUnit);
                requestData.unitId = data.id;
                this.$store
                    .dispatch("apiresource/UpdatePPMPItem", requestData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedRfqItem.unit = data;
                        if(this.selectedRFQ.rfqSuppliers.length > 0){
                            this.selectedRFQ.rfqSuppliers.map(x => {
                                let index = x.supplierRFQ.findIndex(y => y.id == this.selectedRfqItem.id);
                                if(index != -1){
                                    x.supplierRFQ[index].unit = data;
                                }
                            })
                        }
                        this.showToast("Successfully updated", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            });
        },
        postToPublic(row) {
            this.$refs.publicPostModal.onResetPublicPost(row.id);
            this.modalTitle = "Add RFQ Public Posting";
            this.$bvModal.show("modal-post-to-public");
        },
        unPostToPublic(row, type = false){
            if(type){
                this.$store
                    .dispatch("publicpostedrfq/RemovePublicPostRfq", row.publicPostId)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.postedToPublic = false;
                        this.showToast("Successfully unposted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Cannot be unpost!", "error");
                    });
            }else{
                let item = row.publicPostedRfqs[0];
                this.$store
                    .dispatch("publicpostedrfq/RemovePublicPostRfq", item.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.publicPostedRfqs.splice(0, 1);
                        row.postedToPublic = false;
                        this.showToast("Successfully unposted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Cannot be unpost!", "error");
                    });
            }
        },
        postRfqToPublic(modalData){
            if(modalData.id == 0){
                this.$store
                    .dispatch("publicpostedrfq/CreatePublicPostRfq", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.rfqData.findIndex(x => x.id == modalData.rfqId);
                        this.rfqData[index].postedToPublic = true;
                        this.rfqData[index].publicPostId = res.data.id;
                        this.showToast("Successfully posted!", "success");
                        this.$bvModal.hide("modal-post-to-public");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                this.$store
                    .dispatch("publicpostedrfq/UpdatePublicPostRfq", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.showToast("Successfully updated!", "success");
                        this.$bvModal.hide("modal-post-to-public");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        postRFQ(row) {
            if(row.containsRealignedItem){
                return this.showToast("This RFQ contains realigned item. Please remove it first.", "warning");
            }
            var index = this.rfqData.findIndex((x) => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You want to make it as final?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, finalize it!",
            }).then(async (result) => {
                if (result.value) {
                    row.errorPost = false;
                    row.isPosting = true;
                    let winner = [];
                    if (!row.itemLoaded) {
                        this.pageLoader(true);
                        row.postingMessage = "Getting Supplier offers...";
                        await this.wait(1000);
                        await this.showRfqSupplier(row);
                        this.pageLoader(false);
                    }
                    this.pageLoader(true);
                    row.postingMessage = "Determining the winner/s...";
                    await this.wait(3000);
                    for await (const item of row.rfqSuppliers) {
                        item.rfqSupplierOffers = [];
                        item.isWinner = false;
                        for await (const x of item.supplierRFQ) {
                            if (x.offer.isWinner) {
                                let win = winner.find(
                                    (y) => y.itemId == x.offer.rfqItemId
                                );
                                if (!win) {
                                    winner.push({
                                        itemId: x.offer.rfqItemId,
                                        winCount: 1,
                                    });
                                } else {
                                    win.winCount++;
                                    winner.splice(winner.indexOf(win), 1, win);
                                }
                                item.isWinner = true;
                            }
                            if (x.offer.id > 0) {
                                item.rfqSupplierOffers.push(x.offer);
                            }
                        }
                    }
                    if (winner.length == 0) {
                        row.postingMessage =
                            "No winner yet. Please check and try posting again";
                        row.errorPost = true;
                        this.pageLoader(false);
                        await this.wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    let anomaly = false;
                    winner.forEach((item) => {
                        if (item.winCount > 1) {
                            anomaly = true;
                        }
                    });
                    if (anomaly) {
                        row.postingMessage = `There's an anomaly in the winner/s. Please check and try posting again.`;
                        row.errorPost = true;
                        this.pageLoader(false);
                        await this.wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    if (winner.length > row.rfqItems.length) {
                        row.postingMessage = `There's an anomaly in the winner/s. Please check and try posting again.`;
                        row.errorPost = true;
                        this.pageLoader(false);
                        await this.wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    row.postingMessage = "Posting the RFQ...";
                    this.$store
                        .dispatch("rfq/PostRfq", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            row.visible = false;
                            row.errorPost = false;
                            row.isPosting = false;
                            row.publicPostedRfqs = [];
                            row.detailsLoaded = false;
                            row.rfqItems = [];
                            row.rfqBacSettings = [];
                            row.rfqSuppliers = [];
                            row.bacLoading = false;
                            row.rfqItemLoading = false;
                            row.selectItems = false;
                            row.forReAward = false;
                            row.forRecanvas = false;
                            row.selectAll = false;
                            row.poExist = true;
                            this.rfqData.splice(index, 1);
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                }
            });
        },
        updatePRItem(prItem){
            this.modalTitle = 'Update Bid Item';
            this.$bvModal.show('bid-item-modal');
            this.$refs.bidItemModal.updateData(cloneDeep(prItem));
            this.selectedPrItem = prItem;
        },
        viewLogs(prItem){
            this.$refs.itemlog.getData(prItem.apiResourceId);
            this.$bvModal.show("api-resoure-log-modal");
        },
        updateBidItem(modalData){
            this.$store
                .dispatch("pritem/UpdateBidPRItem", modalData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.selectedPrItem.bidItemName = modalData.bidItemName;
                    this.selectedPrItem.bidDescription = modalData.bidDescription;
                    this.$bvModal.hide('bid-item-modal');
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        addActivity(rfq){
            this.selectedRFQ = rfq;
            let ids = rfq.activities.map(item => item.bidActivityId);
            let filteredHeader = [];
            this.bidActivities.map(item => {
                if(!ids.includes(item.id)){
                    filteredHeader.push(item);
                }
            })
            this.filteredHeader = filteredHeader;
            this.$refs.bidActModal.updateData({
                id: 0,
                rfqId: rfq.id,
                bidActivityId: "",
                schedule: "",
                notes: "",
                mode: "",
                bidActivity: null,
            })
            this.modalTitle = "Add Activity";
            this.$bvModal.show("activity-modal");
        },
        onSubmitActivity(modalData){
            let data = cloneDeep(modalData);
            data.schedule = this.getDate(modalData.schedule);
            data.preEventNotification = this.getDate(modalData.preEventNotification);
            if(modalData.id == 0){
                this.$store
                    .dispatch("bidactivityschedule/CreateBidActivitySchedule", data)
                    .then(async (res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedRFQ.activities.push(res.data);
                        this.$bvModal.hide("activity-modal");
                        this.showToast("Activity saved!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong! - saving activity", "error");
                    });
            }else{
                this.$store
                    .dispatch("bidactivityschedule/UpdateBidActivitySchedule", data)
                    .then(async (res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedRFQ.activities.findIndex(x => x.id == modalData.id);
                        this.selectedRFQ.activities.splice(index, 1, data);
                        this.$bvModal.hide("activity-modal");
                        this.showToast("Activity updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong! - saving activity", "error");
                    });
            }
        },
        updateActivity(act, rfq){
            this.selectedRFQ = rfq;
            let data = cloneDeep(act);
            data.rfqId = rfq.id;
            data.schedule = new Date(act.schedule);
            data.bidActivity = {
                id: act.id,
                activityName: act.bidActivity.activityName,
                bidActivityReports: act.bidActivity.bidActivityReports,
            }
            this.$refs.bidActModal.updateData(data);
            this.modalTitle = "Update Activity";
            this.$bvModal.show("activity-modal");
        },
        deleteActivity(act, rfq){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this activity?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("bidactivityschedule/DeleteBidActivitySchedule", act.id)
                        .then(async (res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = rfq.activities.findIndex(x => x.id == act.id);
                            rfq.activities.splice(index, 1);
                            this.showToast("Activity deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong! - deleting activity", "error");
                        });
                }
            });
        },
        async getActivityAttachments(act, pr){
            this.modalTitle = 'Bid Activity Schedule Attachments'
            this.$refs.attachmentModal.setUploadOpt({
                type: "Bid Activity",
                placement: "left",
                folder: "Procurement",
            });
            console.log(act);
            this.modalHeader = `Project Name: ${pr.description}`;
            this.modalSubheader = `${act.bidActivity.activityName}`;
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(act.id);
        },
        createRfq(pr){
            this.$emit('createRfq', pr);
        },
        async generateNotice(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/NoticeOfMeeting",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        async generateUR(id){

        },
        async uploadForUR(parent, {act, actReport}){
            this.$refs.attachmentModal.setUploadOpt({
                type: `BAct URep ${act.activityName} ${parent.id}`,
                placement: "left",
                folder: "Procurement",
            });
            this.modalHeader = `Project Name: ${parent.description}`;
            this.modalSubheader = `${act.activityName} (${actReport.reportType})`;
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(actReport.id);
        },
        changeRFQNo(row){
            this.$bvModal.show('rfq-number-modal');
            this.$refs.rfqNumberModal.getRFQ(row);
            this.selectedRFQForChanging = row;
        },
        updateRFQNumber(rfqNumber){
            this.selectedRFQForChanging.rfqNumber = rfqNumber;
        },
        createMember(data){
            data.rfqId = this.selectedPR.id;
            data.status = 'PENDING';
            this.$store
                .dispatch("rfqbacsetting/AddBACMember", data)
                .then((res) => {
                    if(res.data.error){
                        this.showToast(res.data.errorMessage, 'error');
                    }
                    data.id = res.data.id;
                    this.selectedPR.rfqBacSettings.push(data);
                    this.$bvModal.hide("add-member-modal");
                    this.showToast("Successfully created!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        updateBid(data, pr){
            this.$emit('updateBid', data)
        }
    }
}
</script>
<template>
    <div class="row mt-3">
        <template v-if="loading">
            <div class="row">
                <div class="col-md-3 mb-2" v-for="x in 8" :key="x">
                    <b-skeleton width="100%" height="180px" class="bg-primary bg-soft"></b-skeleton>
                </div>
            </div>
        </template>
        <template v-if="!loading && !rfqData.length">
            <div class="text-center mt-5 pt-5">
                <img src="@/assets/images/small/folder.png" style="height:100px;">
                <h2 class="mt-2">No data found</h2>
            </div>
        </template>
        <template v-if="!loading && rfqData.length">
            <div class="mb-2 d-flex align-items-center" v-for="(x, xIndex) in filteredRfqs" :key="x.id">
                <div class="form-check form-checkbox-outline form-check-success" v-if="menuOpt == 1">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="x.selected"
                    />
                </div>
                <div class="card border w-100 mb-2" :style="{'zIndex': filteredRfqs.length - xIndex}">
                    <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                    <span class="position-absolute pin-span" v-if="!x.expand">
                        <!-- <img 
                            src="@/assets/images/small/pin.png" 
                            alt="pin"
                            v-if="menuOpt == 1"
                        > -->
                        <img 
                            src="@/assets/images/verified-icon.png"
                            alt="verified"
                            v-if="x.postedToPublic"
                        >
                    </span>
                    <div class="card-header" @click="selectRfq(x)">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="w-100" >
                                <template v-if="menuOpt != 1">
                                    <div class="d-flex line-height-1">
                                        <div>
                                            <a href="javascript:void(0);" class="hover-underline text-white" >
                                                <p class="mb-0 d-inline font-size-14" >
                                                    {{x.description}}
                                                </p>
                                            </a>
                                            <img 
                                                src="@/assets/images/verified-icon.png"
                                                alt="verified"
                                                v-if="x.expand && x.postedToPublic"
                                                style="width:22px;height:22px;"
                                            >
                                            <span class="text-green mb-0 cursor-pointer hover-underline" @click.stop="changeRFQNo(x)">[{{x.rfqNumber}}]</span>
                                        </div>
                                    </div>
                                    <div class="d-flex mt-1">
                                        <div>
                                            <div class="ms-1">
                                                <i class="mdi mdi-arrow-right"></i>
                                                <p class="mb-0 d-inline"><i>{{x.prDescription}}</i></p>
                                                <span class="text-yellow font-size-10 ms-1">[{{x.prNumber}}]</span>
                                            </div>
                                            <!-- <small class="font-size-12 text-yellow">{{x.deliveryUnit}}</small> -->
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="d-flex justify-space-between align-items-center w-100">
                                        <div class="w-100">
                                            <span class="text-yellow">[{{x.prNumber}}]:</span>
                                            <a href="javascript:void(0);" class="hover-underline text-white font-size-14" >
                                                {{x.description}}
                                            </a>
                                            <small class="font-size-12 text-yellow d-block">{{x.deliveryUnit}}</small>
                                        </div>
                                        <button type="button" class="btn btn-primary btn-sm text-nowrap" v-if="!x.expand && !selectedPRs.length" @click.stop="createRfq(x)">Create Bid for Sale</button>
                                    </div>
                                </template>
                            </div>
                            <div style="width:30px;" v-if="x.expand">
                                <a href="javascript:void(0)" class="bx bx-x font-size-30 text-muted" @click.stop="x.expand = false"></a>
                            </div>
                        </div>
                    </div>
                    <b-collapse
                        :visible="x.expand"
                        :accordion="`rfq-${x.id}`"
                        role="tabpanel"
                    >
                        <div class="card-body border-top">
                            <b-tabs
                                pills
                                vertical
                                active-nav-item-class="bg-success"
                                nav-class="p-0"
                                nav-wrapper-class="col-sm-2"
                                content-class="pt-0 px-3 text-muted border-start"
                                :key="x.id"
                            >
                                <template v-if="menuOpt != 1">
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-book-content"></i>
                                            Bid Details
                                        </template>
                                        <BidDetails 
                                            :data="x"
                                            @updateBid="updateBid(x)"
                                        />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="showRfqActivities(x)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-detail"></i>
                                            Bid Activities
                                        </template>
                                        <BidSchedules
                                            :data="x"
                                            @addActivity="addActivity(x)"
                                            @updateActivity="updateActivity($event, x)"
                                            @deleteActivity="deleteActivity($event, x)"
                                            @getAttachments="getActivityAttachments($event, x)"
                                            @uploadAttachment="uploadForUR(x, $event)"
                                            @generateReport="generateUR"
                                            @generateNotice="generateNotice"
                                        />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="showRfqItems(x)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-package"></i>
                                            Bid Items
                                        </template>
                                        <BidItems 
                                            :data="x"
                                            :fromPR="false"
                                            @changeUnit="changeUnit($event, x)"
                                            @updatePRItem="updatePRItem"
                                            @viewLogs="viewLogs"
                                        />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="getRFQBacMembers(x)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-run"></i>
                                            BAC Members
                                        </template>
                                        <BACMembers
                                            :data="x"
                                            @updateBACMember="updateBACMember($event, x)"
                                            @addBACMember="addBACMember(x)"
                                            @deleteBACMember="deleteBACMember($event, x)"
                                        />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="showRfqSupplier(x)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-cart"></i>
                                            Supplier &amp; Offers
                                        </template>
                                        <BidSuppliers 
                                            :data="x" 
                                            :suppliers="suppliers"
                                            :rfqType="rfqType"
                                            @addMoreSupplier="addMoreSupplier(x)"
                                            @updateOffer="updateOffer($event, x)"
                                            @addAttachment="addAttachment($event, false)"
                                        />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="getAttachments(x, x.activities)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-paperclip"></i>
                                            Attachments
                                        </template>
                                        <BidAttachments :data="x" />
                                    </b-tab>
                                    <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="getPublicPostAttachments(x)"
                                        v-if="x.postedToPublic"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-chat"></i>
                                            Public Posting Attachments
                                        </template>
                                        <BidPublicPost 
                                            :data="x" 
                                            :publicPostOptions="publicPostOptions" 
                                            @addPublicPost="addPublicPost(x)"
                                            @updatePublicAttachment="updatePublicAttachment($event, x)"
                                        />
                                    </b-tab>
                                </template>
                                <template v-else>
                                     <b-tab 
                                        title-item-class="mb-2" 
                                        title-link-class="ps-3 pe-2"
                                        @click="showPrItems(x)"
                                    >
                                        <template v-slot:title>
                                            <i class="bx bx-package"></i>
                                            Bid Items
                                        </template>
                                        <BidItems 
                                            :data="x"
                                            :fromPR="true"
                                            @changeUnit="changeUnit($event, x)"
                                            @updatePRItem="updatePRItem"
                                        />
                                    </b-tab>
                                    <b-tab title-item-class="mb-2" @click="createRfq(x)">
                                        <template v-slot:title>
                                            <div class="text-center py-5 broken-border">
                                                <i class="bx bx-plus"></i>Create Bid for Sale
                                            </div>
                                        </template>
                                    </b-tab>
                                </template>
                            </b-tabs>
                            <div class="d-flex justify-content-between border-top pt-4" v-if="menuOpt == 2">
                                <div class="d-flex">
                                    <button
                                        type="button"
                                        class="btn btn-success me-2"
                                        @click="postRFQ(x)"
                                        v-if="!x.reAward"
                                    >
                                        <i class="bx bx-check me-1"></i>Finalize Bid Form
                                    </button>
                                    <!-- <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="purple me-2"
                                        toggle-class="text-decoration-none"
                                        menu-class="dropdown-menu"
                                        with-caret
                                    >
                                        <template #button-content>
                                            <i class="bx bx-printer me-1"></i> Generate Bid<i
                                                class="
                                                    mdi mdi-chevron-down
                                                    d-none d-xl-inline-block
                                                    ms-1
                                                "
                                            ></i>
                                        </template>
                                        <b-dropdown-item @click="printRFQ(x.id, 'blank')"
                                            >Blank</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printRFQ(x.id, 'supplier')"
                                            >With Supplier</b-dropdown-item
                                        >
                                    </b-dropdown> -->
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="purple me-2"
                                        toggle-class="text-decoration-none"
                                        menu-class="dropdown-menu"
                                        with-caret
                                    >
                                        <template #button-content>
                                            <i class="bx bx-printer me-1"></i> Generate Bid Reports<i
                                                class="
                                                    mdi mdi-chevron-down
                                                    d-none d-xl-inline-block
                                                    ms-1
                                                "
                                            ></i>
                                        </template>
                                        <b-dropdown-item @click="printInvitation(x.id)"
                                            >Invitation</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printInstruction(x.id)"
                                            >Instruction to Bidders</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printDataSheet(x.id)"
                                            >Data Sheet</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printGeneralContract(x.id)"
                                            >General Conditions of Contract</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printSpecialContract(x.id)"
                                            >Special Conditions of Contract</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printSchedReq(x.id)"
                                            >Schedule of Requirements</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printChecklist(x.id)"
                                            >Checklist of Technical and Financial Documents</b-dropdown-item
                                        >
                                        <b-dropdown-item @click="printSchedules(x.id)"
                                            >Schedule of Bidding Activities</b-dropdown-item
                                        >
                                    </b-dropdown>
                                    <button
                                        type="button"
                                        class="btn btn-purple me-2"
                                        @click="printAbstract(x.id)"
                                    >
                                        <i class="bx bxs-printer me-1"></i>Print Bid Form
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-danger me-2"
                                        @click="deleteRFQ(x.id)"
                                        v-if="!x.reAward"
                                    >
                                        <i class="bx bx-trash me-1"></i>Delete Bid
                                    </button>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-info d-flex align-items-center" @click="postToPublic(x)" v-if="!x.postedToPublic && !x.reAward"><i class="bx bx-repost me-1 font-size-18"></i>Post to Public</button>
                                    <button type="button" class="btn btn-warning d-flex align-items-center" @click="unPostToPublic(x, true)" v-if="x.postedToPublic && !x.reAward"><i class="bx bx-x me-1 font-size-18"></i>UnPost from Public</button>
                                </div>
                            </div>
                            <div 
                                class="d-flex mt-2 align-items-center"
                                v-if="x.isPosting"
                            >
                                <div
                                    class="spinner-border text-success"
                                    role="status"
                                    style="width: 15px; height: 15px;"
                                    v-if="!x.errorPost"
                                >
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div
                                    class="ms-1"
                                    :class="{'text-danger': x.errorPost}"
                                >
                                    {{x.postingMessage}}
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
        <RfqFilePostingModal 
            :filePostingType="filePostingType"
            :multipleFilePosting="multipleFilePosting" 
            :modalTitle="modalTitle"
            :loading="publicPostLoading"
            :publicPostLabels="publicPostLabels"
            @saveFilePosting="saveFilePosting"
        />
        <employee-modal ref="empModal" @dropData="dropSingleEmployee"></employee-modal>
        <supplier-rfq ref="supplier" @dropData="dropSuppliers($event)"></supplier-rfq>
        <AttachmentModal
            :wActions="wActions" 
            :title="modalTitle" 
            ref="attachmentModal"
            :header="modalHeader"
            :subheader="{title: modalSubheader, class: 'text-warning'}"
        />
        <print-options ref="printOpt"></print-options>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <SupplierOfferModal 
            ref="supOfferModal" 
            :offers="offers"
            :units="units"
            :selectedSupplierId="selectedSupplierId"
            @updateReturnDate="updateReturnDate"
            @saveOfferMethod="saveOfferMethod"
            @addAttachment="addAttachment(null, true)"
        />
        <PublicPostModal
            ref="publicPostModal"
            :modalTitle="modalTitle"
            @postRfqToPublic="postRfqToPublic"
        />
        <BidItemModal 
            ref="bidItemModal"
            :modalTitle="modalTitle"
            @update="updateBidItem"
        />
        <BidActivityModal 
            ref="bidActModal" 
            @dropData="onSubmitActivity" 
            :modalTitle="modalTitle"
            :bidActivities="filteredHeader"
            :showAct="true"
        />
        <RFQNumberModal ref="rfqNumberModal" @rfqNumberChanged="updateRFQNumber"/>
        <BACMemberModal @onSubmit="createMember" @openEmployee="selectBACEmployee" ref="addBacModal"/>
        <api-resource-logs ref="itemlog"></api-resource-logs>
    </div>
</template>
<style lang="scss">
.pin-span{
    top: -10px;
    right: -10px;
    img{
        width: 35px;
    }
}
.rfq-sign-left{
    margin-top:8px;
    border-left: 2px solid var(--bs-gray-400);
    border-top-left-radius: 2px;
    width:20px;
    .sign-inner{
        height:2px;
        width:5px;
        background:var(--bs-gray-400);
    }
    &.expand{
        width: 10px;
    }
}
.sign-inner-pr{
    border-left: 2px solid var(--bs-gray-400);
    border-bottom-left-radius: 2px;
    height: calc(50% - 5px);
}
.pr-inner-w{
    width: 40px;
    margin-right: 5px;
    .pr-border-w{
        height: calc(50% - 5px);
        border-bottom: 2px solid var(--bs-gray-400);
    }
    &.expand{
        width: 25px;
    }
}
</style>